"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = exports.sleep = exports.isArrayEqual = exports.overlaps = exports.reverseKeys = exports.getEntries = exports.getKeys = exports.connectArrayIfExist = exports.connectIfExistOrDisconnect = exports.connectIfExist = exports.removeNull = exports.filterObject = exports.isIn = exports.getEnv = exports.assertUnreachable = void 0;
exports.makeEnum = makeEnum;
var moment_1 = __importDefault(require("@ambler/moment"));
var lodash_1 = require("lodash");
var assertUnreachable = function (value) {
    throw new Error("Unexpected value in switch: ".concat(JSON.stringify(value)));
};
exports.assertUnreachable = assertUnreachable;
var getEnv = function (name) {
    var value = process.env[name];
    if (value != undefined) {
        return value;
    }
    throw Error("ENV variable not set: ".concat(name));
};
exports.getEnv = getEnv;
// ? Enforce that the value of Array.include to strictly be of the same type as array elements
// ? and not just string.
var isIn = function (array, value) {
    var array_ = array;
    return value !== undefined && array_.includes(value);
};
exports.isIn = isIn;
/**
 * Filter an object with a custom function.
 * For exampe: `filterObject({a: 5, b: 10, c: 15}, ([k, v]) => v > 10)` will return `{c: 15}`
 * @param o the object to filter
 * @param filterFunction a function that takes a [key,value] pair and returns true to keep the value or false to delete it
 * @returns a *new* object with its keys filtered
 */
var filterObject = function (o, filterFunction) { return o && Object.fromEntries(Object.entries(o).filter(filterFunction)); };
exports.filterObject = filterObject;
/** Remove null and undefined values from an object */
var removeNull = function (o) { return (0, exports.filterObject)(o, function (_a) {
    var _ = _a[0], v = _a[1];
    return v != null;
}); };
exports.removeNull = removeNull;
function makeEnum(types) {
    return types.reduce(function (result, type) {
        result[type] = type;
        return result;
    }, {});
}
var connectIfExist = function (id) { return (id ? { connect: { id: id } } : undefined); };
exports.connectIfExist = connectIfExist;
var connectIfExistOrDisconnect = function (nextId, currentId) {
    if (nextId) {
        return { connect: { id: nextId } };
    }
    if (currentId) {
        return {
            disconnect: true,
        };
    }
    return undefined;
};
exports.connectIfExistOrDisconnect = connectIfExistOrDisconnect;
var connectArrayIfExist = function (ids) {
    return ids ? { connect: ids.filter(Boolean).map(function (id) { return ({ id: id }); }) } : undefined;
};
exports.connectArrayIfExist = connectArrayIfExist;
exports.getKeys = Object.keys;
exports.getEntries = Object.entries;
var reverseKeys = function (value, array) {
    return array.reduce(function (obj, key) {
        obj[key] = value;
        return obj;
    }, {});
};
exports.reverseKeys = reverseKeys;
var overlaps = function (a, b) {
    var _a, _b;
    // ? open ended range are buggy so we use year 3000
    var rangeA = moment_1.default.range((0, moment_1.default)(a.startDate), (0, moment_1.default)((_a = a.endDate) !== null && _a !== void 0 ? _a : '3000-01-01'));
    var rangeB = moment_1.default.range((0, moment_1.default)(b.startDate), (0, moment_1.default)((_b = b.endDate) !== null && _b !== void 0 ? _b : '3000-01-01'));
    return rangeA.overlaps(rangeB);
};
exports.overlaps = overlaps;
// ! https://stackoverflow.com/questions/37065663/array-of-object-deep-comparison-with-lodash
var isArrayEqual = function (x, y) { return (0, lodash_1.isEmpty)((0, lodash_1.xorWith)(x, y, lodash_1.isEqual)); };
exports.isArrayEqual = isArrayEqual;
var sleep = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
exports.sleep = sleep;
var isDefined = function (value) { return value != null; };
exports.isDefined = isDefined;
//# sourceMappingURL=utils.js.map